import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { STAFF_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { staffService } from '@/services/staff';

const resetStaffFactors = async (staffID: string) => errorUtils.unwrap(await staffService.resetFactors(staffID));

const useResetStaffFactors = () => {
  const queryClient = useQueryClient();

  return useMutation<number, Error, string>({
    meta: notifyMeta('staffFactorsReset'),
    mutationKey: ['staff', 'factor-reset'],
    mutationFn: resetStaffFactors,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: STAFF_KEYS.factors() });
    },
  });
};

export {
  useResetStaffFactors,
};
